import { useDispatch, useSelector } from "react-redux";
import { printDividendThunk } from "../thunks/printDividendThunk";
import React from "react";
import { StoreType } from "../../../../core/store/reducers";
import { FetchStateType } from "../../../models";
import { DividendData } from "../types";

export const useDividendsPrinter = (dividend?: DividendData) => {
	const fetchState = useSelector<StoreType, FetchStateType>(
		s => s.data.reports.dividends.printDividendFetchState
	);
	const dispatch = useDispatch();
	const download = React.useCallback(() => {
			dispatch(printDividendThunk(dividend));
	}, [dispatch, dividend]);

	return [download, fetchState] as [typeof download, typeof fetchState];
};
